var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndoTooltipIcon = function SvgIndoTooltipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "indo-tooltip-icon_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#indo-tooltip-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M9.374 13.958h1.25V9.166h-1.25zm.625-6.218q.285 0 .48-.193a.65.65 0 0 0 .193-.48q0-.285-.194-.48a.65.65 0 0 0-.48-.193q-.285 0-.479.193a.65.65 0 0 0-.193.48q0 .285.193.48a.65.65 0 0 0 .48.193M10 17.916a7.7 7.7 0 0 1-3.088-.623 8 8 0 0 1-2.514-1.692 8 8 0 0 1-1.692-2.513 7.7 7.7 0 0 1-.624-3.087q0-1.642.623-3.088A8 8 0 0 1 4.397 4.4 8 8 0 0 1 6.91 2.707a7.7 7.7 0 0 1 3.087-.624q1.642 0 3.088.623 1.444.624 2.514 1.692a8 8 0 0 1 1.693 2.513q.623 1.445.623 3.087a7.7 7.7 0 0 1-.623 3.088A8 8 0 0 1 15.6 15.6a8 8 0 0 1-2.513 1.693 7.7 7.7 0 0 1-3.087.623M10 16.666q2.79 0 4.729-1.937 1.937-1.937 1.937-4.73 0-2.79-1.937-4.729-1.937-1.937-4.73-1.937-2.79 0-4.728 1.937T3.332 10q0 2.79 1.938 4.729 1.937 1.937 4.729 1.937"
  }))));
};
export default SvgIndoTooltipIcon;